<table mat-table matSort matSortDisableClear="true" (matSortChange)="setSorts()" matSortActive="eventDate" matSortDirection="desc" [dataSource]="eventDataSource" multiTemplateDataRows class="w-full">
  <ng-container matColumnDef="eventDate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
    <td mat-cell *matCellDef="let event">
      {{ event.eventDate | date: 'M/dd/yyyy' }}
    </td>
  </ng-container>
  <ng-container matColumnDef="actionBy">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">
      <div class="text-left">Action By</div>
    </th>
    <td mat-cell *matCellDef="let event">
      {{ event.actionBy }}
    </td>
  </ng-container>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">Event</th>
    <td mat-cell *matCellDef="let event">
      <!-- If app type is prequal show 'Rated' -->
      <div>{{ event.name === 'Approved' ? approvedTerm : event.name }}</div>
    </td>
  </ng-container>
  <ng-container matColumnDef="comment">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">Comment</th>
    <td mat-cell *matCellDef="let event">
      <div class="comment-block trunc-comment" #commentBlock>
        <span class="trunc">{{ event.comment.substr(0, 65) }}{{ event.comment?.length > 65 ? '...' : '' }}</span>
        @if (event.comment?.length > 65) {
          <span class="link" (click)="expandedElement = expandedElement === event ? null : event; $event.stopPropagation()"> Show {{ expandedElement === event ? 'Less' : 'More' }}</span>
        }
      </div>
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let event" [attr.colspan]="eventsColumnsToDisplay.length">
      @if (event.comment.length > 65) {
        <div class="full-comment" [@detailExpand]="event === expandedElement ? 'expanded' : 'collapsed'">
          {{ event.comment }}
        </div>
      }
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="eventsColumnsToDisplay"></tr>
  <tr mat-row *matRowDef="let row; columns: eventsColumnsToDisplay" class="comment-row hover:bg-gray-100" [class.example-expanded-row]="expandedElement === row" [class.cursor-pointer]="row.comment.length > 65" (click)="expandedElement = expandedElement === row ? null : row"></tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="full-comment-row"></tr>
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" colspan="7">
      <em> There are currently no events to display. </em>
    </td>
  </tr>
</table>
<mat-paginator #eventPaginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" aria-label="Select page"></mat-paginator>
